import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';

export default function Admin() {
  const { user } = useAuth();

  return <AdminDashboard user={user} />;
}